import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Pessoa } from '../models/pessoa';

export function getHeaders() {
  let headers = new HttpHeaders().append(
    'Content-Type',
    'application/json; charset=utf-8'
  );
  return headers;
}

@Injectable({
  providedIn: 'root',
})
export class PessoaService {
  uri = environment.urlApi.concat('/v1/pessoa');

  constructor(private http: HttpClient) {}

  listById(ids: string[]) {
    return this.http.post<Pessoa[]>(this.uri.concat('/listById'), ids, {
      headers: getHeaders(),
    });
  }

  listByDocumento(docs: string[]) {
    return this.http.post<Pessoa[]>(this.uri.concat('/listByDocumento'), docs, {
      headers: getHeaders(),
    });
  }

  listByAcessos(ids: string[]) {
    return this.http.post<Pessoa[]>(this.uri.concat('/listByAcessos'), ids, {
      headers: getHeaders(),
    });
  }

  buscaPessoa(palavra: string) {
    return this.http.post<Pessoa[]>(this.uri.concat('/search'), palavra, {
      headers: getHeaders(),
    });
  }

  searchSacado(dados: any) {
    return this.http.post<any>(this.uri.concat('/search/sacado'), dados, { headers: getHeaders() });
  }

  buscaCedenteSacado(dados: any) {
    return this.http.post<any>(this.uri.concat('/search/sacadoOrCedente'), dados, { headers: getHeaders() });
  }
}
